var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { locale as polish } from '../../../../translations/pl';
import { locale as english } from '../../../../translations/en';
import { MatDialog } from '@angular/material';
import { FractionsService } from '../../../../services/fractions.service';
import { FractionEditorComponent } from '../fraction-editor/fraction-editor.component';
import { List } from '../../../../shared/models/list.class';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
var FractionsListComponent = /** @class */ (function (_super) {
    __extends(FractionsListComponent, _super);
    function FractionsListComponent(fractionsService, matDialog, authService, _fuseTranslationLoaderService) {
        var _this = _super.call(this) || this;
        _this.fractionsService = fractionsService;
        _this.matDialog = matDialog;
        _this.authService = authService;
        _this._fuseTranslationLoaderService = _fuseTranslationLoaderService;
        _this.displayedColumns = ['name', 'description', 'code', 'active'];
        _this.listFilters = {};
        _this._fuseTranslationLoaderService.loadTranslations(polish, english);
        _this.reloadList$ = fractionsService.onEditEvent.subscribe(function () {
            _this.getElementsList();
        });
        _this.getElementsList = function () {
            _this.fractionsService.getFractionsList(_this.getQueryParams())
                .subscribe(function (res) {
                _this.totalCount = res.totalCount;
                _this.dataSource = res.fractions;
            });
        };
        return _this;
    }
    FractionsListComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.user = this.authService.getUser();
        this.createSearchFormControl();
    };
    FractionsListComponent.prototype.ngOnDestroy = function () {
        this.reloadList$.unsubscribe();
    };
    FractionsListComponent.prototype.addFraction = function () {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(FractionEditorComponent, {
            panelClass: 'fraction-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'add'
            }
        });
    };
    FractionsListComponent.prototype.viewFraction = function (fractionUuid) {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(FractionEditorComponent, {
            panelClass: 'fraction-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'view',
                fractionUuid: fractionUuid
            }
        });
    };
    FractionsListComponent.prototype.clearSearch = function () {
        if (this.searchFraction.value) {
            this.searchFraction.setValue('');
        }
    };
    FractionsListComponent.prototype.getListFilters = function (filters) {
        this.listFilters = filters;
        this.requestParams.page = 1;
        this.disableAnimations = true;
        this.getElementsList();
    };
    FractionsListComponent.prototype.createSearchFormControl = function () {
        var _this = this;
        this.searchFraction = new FormControl('');
        this.searchFraction.valueChanges.debounceTime(300).subscribe(function (value) {
            _this.requestParams.search = value;
            _this.requestParams.page = 1;
            _this.disableAnimations = true;
            _this.getElementsList();
        });
    };
    FractionsListComponent.prototype.getQueryParams = function () {
        return Object.assign({}, this.requestParams, this.listFilters);
    };
    return FractionsListComponent;
}(List));
export { FractionsListComponent };
